import * as z from 'zod/v4';

import { drawNumberSchema } from '../draw/entry.js';
import { customerIdSchema } from '../lib/entry.js';
import { activatedDrawIdSchema } from './activatedDrawId.js';

const marketplaceGroupsContainerWithDrawSchema = z.object({
  activatedDrawId: activatedDrawIdSchema,
  activatedDrawStatus: z.number(),
  drawNumber: drawNumberSchema,
  regClose: z.string().transform((str) => new Date(str)),
  wagerSerial: z.string().nullable(),
  memberMaxShares: z.number(),
  maxShares: z.number(),
  shareCommittedPrice: z.string().nullable(),
  totalBalance: z.string(),
  wagerAmount: z.string().nullable(),
  wagerSharePrice: z.string().nullable(),
  isSubmittable: z.boolean(),
  isAllowedToSubmit: z.boolean(),
  currentUserNumberOfShares: z.number(),
  soldShares: z.number(),
  buyinCloseTime: z.string().transform((str) => new Date(str)),
  activatedDrawName: z.string(),
  subProductId: z.number(),
  preliminaryRowExists: z.boolean(),
  description: z.string().nullable(),
  editorName: z.string().optional(),
  numShares: z.number(),
  sharePrice: z.string(),
  containerId: z.number(),
  editorId: z.number(),
  groupId: z.number(),
  productId: z.number(),
  name: z.string(),
});

const marketplaceGroupsSchema = z.object({
  currentUserAutobuyin: z
    .object({
      autobuyinId: z.number(),
      maxWeeklyAmount: z.string(),
      remainingWeeklyAmount: z.string(),
    })
    .nullable(),
  numberOfContainersWithDraw: z.number(),
  containersWithDraw: z.array(marketplaceGroupsContainerWithDrawSchema),
  groupId: z.number(),
  name: z.string(),
  groupType: z.number(),
  groupStatus: z.number(),
  groupStatusReason: z.number().optional(),
  numberOfMembers: z.number(),
  allowsEntry: z.boolean(),
  maxMembers: z.number(),
  currentUserRoleInGroup: z.number(),
  currentUserStatusInGroup: z.number(),
  address: z.string().optional(),
  city: z.string().optional(),
  description: z.string().optional(),
  email: z.string().optional(),
  imageId: z.string().optional(),
  phone: z.string().optional(),
  website: z.string().optional(),
});

export const marketplaceGroupsResponse = z.object({
  count: z.number(),
  offset: z.number(),
  totalHits: z.number(),
  customerId: customerIdSchema,
  groups: z.array(marketplaceGroupsSchema),
});
